const showTab = (paragraph, index) => {
  const contents = paragraph.querySelectorAll(".paragraph-download-category");
  const tabs = paragraph.querySelectorAll(".paragraph-download-tabs li");

  for (const tab of tabs) {
    tab.classList.remove("is-active");
  }
  for (const content of contents) {
    content.style.display = "none";
  }

  tabs[index].classList.add("is-active");
  contents[index].style.display = "block";
};

const tabs = () => {
  const paragraphs = document.querySelectorAll(".paragraph-download");

  for (const paragraph of paragraphs) {
    const tabs = paragraph.querySelectorAll(".paragraph-download-tabs li");
    const select = paragraph.querySelector(".paragraph-download-select select");

    if (tabs.length) {
      showTab(paragraph, 0);

      for (const [index, tab] of tabs.entries()) {
        tab.addEventListener("click", () => {
          showTab(paragraph, index);
        });
      }

      select.addEventListener("change", () => {
        showTab(paragraph, select.selectedIndex);
      });
    }
  }
};

export default tabs;
